// @flow

export type modelEnum =
  | 'Célibataire'
  | 'Rentier'
  | 'Marié sans enfants'
  | 'Marié revenu simple avec deux enfants'
  | 'Marié double revenu avec deux enfants'

export const model: { [key: string]: modelEnum } = {
  SINGLE: 'Célibataire',
  RETIRED: 'Rentier',
  MARRIED_WITHOUT_CHILDREN: 'Marié sans enfants',
  MARRIED_WITH_CHILDREN: 'Marié revenu simple avec deux enfants',
  MARRIED_WITH_CHILDREN_AND_DUAL_INCOME:
    'Marié double revenu avec deux enfants'
}

export default model



// WEBPACK FOOTER //
// ./src/components/selector/models.js